import React from 'react'

import { RoutesArray } from 'ui/components/Navigation/types'

const LoginView = React.lazy(() => import('views/LoginView/LoginView'))
const ResetPasswordView = React.lazy(() => import('views/ResetPasswordView/ResetPasswordView'))
const AccountActivationView = React.lazy(() => import('views/AccountActivationView/AccountActivationView'))
const ExperimentsView = React.lazy(() => import('views/ExperimentsView/ExperimentsView'))

const indexRoutes: RoutesArray = [
  {
    // Intentionally available without authentication so we can have
    // experiments also for the login page and logged out users.
    path: `/experiments`,
    component: ExperimentsView,
    exact: true,
  },
  {
    path: `/pswdreset/:uid/:token`,
    component: ResetPasswordView,
    exact: true,
  },
  {
    path: `/accountverification/:email/:token`,
    component: AccountActivationView,
    exact: true,
  },
  { path: `/`, component: LoginView },
]

export default indexRoutes
